/**
 * Created by DejanK on 6/29/2017.
 */
'use strict';

let lodash = require('lodash');

require('./rb-negotiations-rate-history.scss');

module.exports = {
  template: require('./rb-negotiations-rate-history.html'),
  bindings: {
    negotiations: '<',
    negotiation: '<',
    rate: '<'
  },
  controller: Ctrl
};

Ctrl.$inject = ['$element', 'NegotiationsHtmlFactory'];
function Ctrl($element, NegotiationsHtmlFactory) {
  let vm = this, tooltipster,
    htmlContentElement, parentElement, tableElement;

  this.$onInit = ()=>{
    parentElement = $element.parent();
    htmlContentElement = $($element.children()[0]);
    tableElement = $(htmlContentElement.find('div.table'));

    parentElement.tooltipster({
      theme: ['', 'negotiations-rate-history'],
      content: htmlContentElement,
      contentAsHtml: true,
      distance: 0,
      interactive: true,
      functionBefore: printHistory,
      functionReady: scrollToActive
    });

    tooltipster = parentElement.tooltipster('instance');
  };

  this.$onChanges = ()=>{
    updateVM();
  };

  this.$onDestroy = ()=>{
    tooltipster.destroy();
  };

  function updateVM(){
    if(!checkRequirements()) return;
    vm.seasonPeriod = vm.negotiations.seasons.getFormattedPeriod(vm.rate.season);
    vm.roomType = vm.negotiations.roomTypes.print(vm.rate.roomType);
  }

  function printHistory(){
    if(!checkRequirements()) return;
    let html = NegotiationsHtmlFactory.printRateHistory(vm.negotiations.communication, vm.rate.id, vm.negotiation);
    tableElement.empty();
    tableElement.append(html);
  }

  function checkRequirements(){
    return vm.negotiations && vm.rate;
  }

  function scrollToActive(){
    let activeElements = tableElement.find('div.layout-row.active');
    if(activeElements.length) {
      scrollTo(tableElement, $(activeElements[0]));
    } else {
      tableElement[0].scrollTop = tableElement[0].scrollHeight;
    }

    function scrollTo(container, scrollTo){
      container.scrollTop(
        scrollTo.offset().top - container.offset().top + container.scrollTop() - (container.height()/2)
      );
    }
  }
}
